import React, { useEffect, useState } from "react";
import { Col, FormGroup, Label } from "reactstrap";
import parse from "html-react-parser";
import InputDescription from "../../InputUtils/InputDescription";
import useStaticFormListener from "../../../hooks/useStaticFormListener";
import authenticatedFetcher from "../../../services/fetcher";

const TypeStatic = ({
  label,
  value,
  labelColumn = {
    xs: 6,
    md: 2,
  },
  inputColumn = {
    xs: 6,
    md: 10,
  },
  relatedData,
  options = {},
  formData,
  options: inputConfig,
  globalParams = {},
  onChange,
  name,
}) => {
  const [customParams] = useStaticFormListener({ options, formData });

  useEffect(() => {
    if (Object.values(customParams).length) handleSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customParams]);

  const handleSearch = async () => {
    const params = inputConfig.params ? inputConfig.params : {};
    const paramsFixed = inputConfig["params-fixed"]
      ? inputConfig["params-fixed"]
      : {};
    const data = await authenticatedFetcher({
      path: `${inputConfig.endpoint}`,
      urlParams: {
        ...globalParams,
        ...params,
        ...paramsFixed,
        ...customParams,
        from_select: 1,
      },
    });
    onChange({
      target: {
        name,
        value: data[inputConfig.key],
      },
    });
  };
  return (
    <FormGroup tag="fieldset" row>
      <Col {...labelColumn}>
        <Label>{label}</Label>
      </Col>
      <Col {...inputColumn}>
        {typeof value === "string" ? parse(value) : value}
        <InputDescription
          description={
            relatedData
              ? relatedData.description
                ? "<br/><br/>" + relatedData.description
                : ""
              : ""
          }
        />
      </Col>
    </FormGroup>
  );
};

TypeStatic.propTypes = {};

export default TypeStatic;
